/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * 
 * @export
 * @interface EntityLockTokenDto
 */
export interface EntityLockTokenDto {
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenDto
     */
    readonly entityId: string;
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenDto
     */
    readonly entityType: string;
    /**
     * 
     * @type {number}
     * @memberof EntityLockTokenDto
     */
    readonly userId: number;
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenDto
     */
    readonly sessionInfoId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenDto
     */
    readonly creationTime: string;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof EntityLockTokenDto
     */
    creatorUser: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenDto
     */
    readonly lastRequest: string;
    /**
     * 
     * @type {number}
     * @memberof EntityLockTokenDto
     */
    readonly renewalTime: number;
    /**
     * 
     * @type {number}
     * @memberof EntityLockTokenDto
     */
    readonly renewalTimeout: number;
    /**
     * 
     * @type {string}
     * @memberof EntityLockTokenDto
     */
    $type?: EntityLockTokenDtoTypeEnum;
}


/**
 * @export
 */
export const EntityLockTokenDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoEntityLockTokensEntityLockTokenDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.EntityLockTokens.EntityLockTokenDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EntityLockTokenDtoTypeEnum = typeof EntityLockTokenDtoTypeEnum[keyof typeof EntityLockTokenDtoTypeEnum];



/**
 * Check if a given object implements the EntityLockTokenDto interface.
 */
export function instanceOfEntityLockTokenDto(value?: unknown): value is EntityLockTokenDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EntityLockTokenDtoTypeEnum)[0];
}

export function EntityLockTokenDtoFromJSON(json: any): EntityLockTokenDto {
    return EntityLockTokenDtoFromJSONTyped(json, false);
}

export function EntityLockTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityLockTokenDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityId': json['entityId'],
        'entityType': json['entityType'],
        'userId': json['userId'],
        'sessionInfoId': json['sessionInfoId'] == null ? undefined : json['sessionInfoId'],
        'creationTime': json['creationTime'],
        'creatorUser': UserCatalogDtoFromJSON(json['creatorUser']),
        'lastRequest': json['lastRequest'],
        'renewalTime': json['renewalTime'],
        'renewalTimeout': json['renewalTimeout'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EntityLockTokenDtoToJSON(value?: Omit<EntityLockTokenDto, 'entityId'|'entityType'|'userId'|'sessionInfoId'|'creationTime'|'lastRequest'|'renewalTime'|'renewalTimeout'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        '$type': value['$type'],
    });
}

